import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PasskeyService} from '../../_services';
import {environment} from '../../../environments/environment';

/**
 * JS-1396 [A] — the landing page for the emailed reset link.
 *
 * This is the one passkey screen that takes its token from the URL, because
 * it arrives from an email and has nowhere else to get one. That is safe
 * here in a way it would not be on the other screens: the token is single
 * use, it grants no session, and redeeming it only ever DELETES the
 * account's passkeys. A replay from browser history finds a consumed token
 * and achieves nothing.
 *
 * It redeems on load rather than behind a button. The mail already said what
 * clicking would do, and a confirm step here would only strand people who
 * close the tab while their account is still in the state the mail told them
 * it would not be.
 */
@Component({
  moduleId: module.id,
  selector: 'app-passkey-reset',
  templateUrl: `../views/passkey-reset.component.html`,
  styleUrls: ['../styles/auth-style.scss']
})
export class PasskeyResetComponent implements OnInit {
  public logoUrl = environment.logoUrl;
  public working = true;
  public succeeded = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private passkeyService: PasskeyService
  ) {
  }

  ngOnInit() {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.working = false;
      this.succeeded = false;
      return;
    }

    this.passkeyService.resetConfirm(token).subscribe(() => {
      this.working = false;
      this.succeeded = true;
    }, () => {
      this.working = false;
      this.succeeded = false;
    });
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
